import React from 'react';
import { Button } from '@chakra-ui/react';

import Finger from '../finger';
import { FingerWithButtons } from '../../Finger/FingerWithButtons';

export enum Status {
  Todo = 'Todo',
  InProgress = 'InProgress',
  Complete = 'Complete',
  InError = 'InError',
  AtRisk = 'AtRisk',
  Locked = 'Locked',
}

export interface Props extends React.HTMLProps<HTMLDivElement> {
  id?: string;
  status: Status;
  label: string;
  hasStart?: boolean;
  isCheckedOff?: boolean;
  canCheckOff?: boolean;
  noEdit?: boolean;
  isBeginCasRequest?: boolean;
  onClick: () => void;
  onCheckOffRisk?: () => void;
  showAction?: boolean;
  children?: React.ReactNode;
  deletedByTTL?: boolean;
}

function FingerWithAction(props: Props) {
  const {
    id = 'finger',
    status,
    hasStart,
    label,
    noEdit,
    isBeginCasRequest,
    onClick,
    isCheckedOff,
    onCheckOffRisk,
    showAction = true,
    canCheckOff = false,
    children,
  } = props;

  const getButtonProps = () => {
    if (hasStart && !(status !== Status.Todo && status !== Status.AtRisk)) {
      return { text: 'Start', variant: 'solid' };
    }
    if (status === Status.Complete || status === Status.AtRisk) {
      return { text: 'Edit', variant: 'secondary' };
    }
    if (isBeginCasRequest) {
      return { text: 'Begin CAS Request', variant: 'solid' };
    }
    if (status === Status.InProgress) {
      return { text: 'Resume', variant: 'solid' };
    }
  };

  const buttonProps = getButtonProps();

  const Actions = () => {
    if (buttonProps && showAction && !noEdit && status !== Status.Todo) {
      return (
        <Button data-selector={`${id}-action`} onClick={onClick} variant={buttonProps.variant}>
          {buttonProps.text}
        </Button>
      );
    }
    return;
  };

  return (
    <FingerWithButtons actions={<Actions />} className="finger-with-action" data-selector={`${id}-div`}>
      <Finger
        id={id}
        status={status}
        label={label}
        isCheckedOff={isCheckedOff}
        canCheckOff={canCheckOff}
        onCheckOffRisk={onCheckOffRisk}
      >
        {children}
      </Finger>
    </FingerWithButtons>
  );
}

export default FingerWithAction;
